export const extractDate = (date: Date) => {

  const year = date.getFullYear();
  const month = date.getMonth() + 1; 
  const day = date.getDate(); 

  // Ensure month and day are in 'MM' or 'DD' format
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;

  // Combine in 'Y-M-D' format
  return `${year}-${formattedMonth}-${formattedDay}`;
}